import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {jwtDecode} from "jwt-decode";
import {ACCESS_TOKEN, CLIENTS, INITIAL_TOKEN} from "../../constants";
import {logout} from "../../actions/LoginActions";

const useAuthPublicPagesRedirect = (claimStage) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const history = useNavigate();

    useEffect(() => {
        const initialToken = localStorage.getItem(INITIAL_TOKEN);
        const accessToken = localStorage.getItem(ACCESS_TOKEN);

        if (accessToken && localStorage.getItem(CLIENTS)) {
            const decodedToken = jwtDecode(accessToken);
            const isSuperAdmin = decodedToken.IsSuperAdmin;

            if (isSuperAdmin === "True") {
                window.location.href = "/super-admin-management";
            } else {
                return;
            }
        }

        if (!localStorage.getItem(CLIENTS)) {
            logoutAndRedirect();
        }

        if (initialToken) {
            const decodedToken = jwtDecode(initialToken);

            const isSuperAdmin = decodedToken.IsSuperAdmin;

            if (isSuperAdmin === "True") {
                window.location.href = "/super-admin-management";
            }

            if (!decodedToken?.signInStage) {
                logoutAndRedirect();
            }

            if (decodedToken?.signInStage !== claimStage) {
                logoutAndRedirect();
            }
        }
    }, [dispatch, navigate, claimStage]);

    const logoutAndRedirect = () => {
        dispatch(logout());
        history('/sign-in');
    };
};

export default useAuthPublicPagesRedirect;